export default "__VITE_ASSET__DRDRxGBU__"